import { TFunction } from 'i18next'

export const countryCodes = {
  germany: 'DEU',
  france: 'FRA',
  switzerland: 'CHE',
  netherlands: 'NLD',
  italy: 'ITA',
  poland: 'POL',
  portugal: 'PRT',
  spain: 'ESP',
  sweden: 'SWE',
  czechia: 'CZE',
  austria: 'AUT',
  southAfrica: 'ZAF',
  luxembourg: 'LUX',
  bosniaAndHerzegovina: 'BIH',
  croatia: 'HRV',
  denmark: 'DNK',
  belgium: 'BEL',
  greece: 'GRC',
} as const

export type CountryCodes = (typeof countryCodes)[keyof typeof countryCodes]

export const getCountryOptions = (t: TFunction): Options<CountryCodes> => [
  { value: 'DEU', label: t('common.countries.germany') },
  { value: 'FRA', label: t('common.countries.france') },
  { value: 'CHE', label: t('common.countries.switzerland') },
  { value: 'NLD', label: t('common.countries.netherlands') },
  { value: 'ITA', label: t('common.countries.italy') },
  { value: 'POL', label: t('common.countries.poland') },
  { value: 'PRT', label: t('common.countries.portugal') },
  { value: 'ESP', label: t('common.countries.spain') },
  { value: 'SWE', label: t('common.countries.sweden') },
  { value: 'CZE', label: t('common.countries.czechia') },
  { value: 'AUT', label: t('common.countries.austria') },
  { value: 'ZAF', label: t('common.countries.southAfrica') },
  { value: 'LUX', label: t('common.countries.luxembourg') },
  { value: 'BIH', label: t('common.countries.bosniaAndHerzegovina') },
  { value: 'HRV', label: t('common.countries.croatia') },
  { value: 'DNK', label: t('common.countries.denmark') },
  { value: 'BEL', label: t('common.countries.belgium') },
  { value: 'GRC', label: t('common.countries.greece') },
]
